module.exports = __webpack_public_path__ + "static/media/1_4.f6233d31.png";